import PropTypes from "prop-types";
import React from "react";
import { ArrowDown, ArrowUp, ArrowHover, } from "../../../assets/icons";

const TableHeaderColumn = ({
    headerText,
    sortKey,
    colClass = "",
    requestSort,
    getArrowDirectionFor
}) => {
    return (
      <th className={`${colClass} textEllipsis headerSorted`}>
        <div onClick={() => requestSort(sortKey)} className={'sortedCenter'}>
          <div className="containerTextSorted">
            <p className="textSorted">{headerText}</p>
          </div>
          {getArrowDirectionFor(sortKey, "descending") && (
            <img className="arrowDirection" alt="Arrow down" src={ArrowDown}/>
          )}
          {getArrowDirectionFor(sortKey, "ascending") && (
            <img className="arrowDirection" alt="Arrow up" src={ArrowUp}/>
          )}
          {getArrowDirectionFor(sortKey) && (
            <img className="arrowDirectionHover" alt="Arrow sort" src={ArrowHover}/>
          )}
        </div>
      </th>
    );
};

TableHeaderColumn.propTypes = {
    headerText: PropTypes.string.isRequired,
    sortKey: PropTypes.string.isRequired,
    colClass: PropTypes.string,
    requestSort: PropTypes.func.isRequired,
    getArrowDirectionFor: PropTypes.func.isRequired,
};

export default TableHeaderColumn;
